import React from 'react';
import './packagesInr.css';
import { Input } from '@mui/material';

const PackagesInrCard = ({ packagesInr, setPackagesInr, gst = 0, isGst }) => {
  const handleChange = (index, field, value) => {
    const updated = [...packagesInr];
    updated[index][field] = value;
    setPackagesInr(updated);
  };

  const addPackage = (e) => {
    e.preventDefault();
    setPackagesInr([
      ...packagesInr,
      {
        packageName: '',
        packagePrice: '',
        totalSeats: '',
        nights: '',
      },
    ]);
  };

  const removePackage = (index) => {
    const updated = packagesInr.filter((_, i) => i !== index);
    setPackagesInr(updated);
  };

  // const getFinalPrice = (price, nights) => {
  //   if (!isGst || !price) return price || 0;
  //   return (Number(price) * nights + (Number(price) * gst) / 100).toFixed(2);
  // };

  const getFinalPrice = (price, nights = 1) => {
    if (!price) return 0;

    const baseAmount = Number(price) * Number(nights);

    if (!isGst) return baseAmount;

    const gstAmount = (baseAmount * Number(gst)) / 100;
    return Number((baseAmount + gstAmount).toFixed(2));
  };

  return (
    <div className="pkg-wrapper">
      <h3>Packages (INR)</h3>

      {packagesInr.map((pkg, index) => (
        <div className="pkg-card" key={index}>
          <div>
            <p style={{ textAlign: 'left', padding: '4px', fontFamily: 'Arial' }}>Package Name</p>
            <Input
              id={`packageName-${index}`}
              placeholder="Package Name"
              value={pkg.packageName}
              onChange={(e) => handleChange(index, 'packageName', e.target.value)}
            />
          </div>

          <div>
            <p style={{ textAlign: 'left', padding: '4px', fontFamily: 'Arial' }}>Price</p>
            <Input
              type="number"
              placeholder="Price"
              value={pkg.packagePrice}
              onChange={(e) => handleChange(index, 'packagePrice', e.target.value)}
            />
          </div>

          <div>
            <p style={{ textAlign: 'left', padding: '4px', fontFamily: 'Arial' }}>Total Seats</p>
            <Input
              type="number"
              placeholder="Seats"
              value={pkg.totalSeats}
              onChange={(e) => handleChange(index, 'totalSeats', e.target.value)}
            />
          </div>

          <div>
            <p style={{ textAlign: 'left', padding: '4px', fontFamily: 'Arial' }}>Nights</p>
            <Input
              type="number"
              placeholder="Nights"
              value={pkg.nights}
              onChange={(e) => handleChange(index, 'nights', e.target.value)}
            />
          </div>

          <div className="price">
            1 Night {pkg.packagePrice} x {pkg.nights} = ₹{getFinalPrice(pkg.packagePrice, pkg.nights)} with GST{' '}
            {isGst === 'true' ? `(${gst}%)` : '(0%)'}
          </div>

          <button
            className="delete"
            onClick={(e) => {
              e.preventDefault();
              removePackage(index);
            }}
          >
            Delete
          </button>
        </div>
      ))}

      <button className="add" onClick={addPackage}>
        + Add Package
      </button>
    </div>
  );
};

export default PackagesInrCard;
